import React, { useEffect, useState } from "react";
import { Button, Form } from "reactstrap";
import { Link } from "react-router-dom";
import "../../assets/css/common.css";
import Logo from "../../components/Logo";
import { confirmPasswordReset } from "../../API/userApi";
import { CheckPassword } from "../../functions/authFns/passwordFn";

/**
 * Where the emailed reset link lands: /reset-password#token=...
 *
 * The token is in the fragment, so it is never sent to the hosting server. It
 * is read once and removed from the address bar so it does not linger in
 * history or get copied along with the URL.
 */
const readTokenFromUrl = () => {
  const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
  return params.get("token") || "";
};

const ResetPassword = () => {
  const [token] = useState(readTokenFromUrl);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(null);
  const [done, setDone] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (window.location.hash) {
      window.history.replaceState(null, "", window.location.pathname);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (saving) return;
    setError(null);

    const rule = CheckPassword(newPassword);
    if (rule !== "Password is valid!") {
      setError(rule);
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("The two passwords do not match.");
      return;
    }

    setSaving(true);
    try {
      const result = await confirmPasswordReset({ token, newPassword });
      setDone(result?.message || "Your password has been changed.");
    } catch (err) {
      setError(err?.response?.data?.message || "Could not reset the password. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="row signup_mobile_container full_view_container">
      <div className="col-xl-5 col-lg-5 col-md-5 hide_img">
        <div className="reset_banner_img" />
      </div>
      <div className="col-xl-7 col-lg-7 col-md-7 col-sm-12">
        <div className="padding_left_signup ">
          <div style={{ marginTop: 70 }}>
            <Logo />
          </div>
          <h4 className="heading" style={{ marginTop: 50 }}>
            Choose a new password
          </h4>

          {done ? (
            <>
              <p className="status-message" role="status">{done}</p>
              <Link to="/">Go to sign in</Link>
            </>
          ) : !token ? (
            <>
              <p className="status-message" role="alert">
                This page needs the link from your password reset email. Open the
                link from the email, or request a new one.
              </p>
              <Link to="/email-verify">Request a reset link</Link>
            </>
          ) : (
            <>
              <p className="subheading" style={{ marginTop: -5 }}>
                At least 8 characters, with an uppercase letter, a lowercase letter and a number.
              </p>
              {error && (
                <p style={{ color: "#b3261e", marginTop: 8 }} role="alert">
                  {error}{" "}
                  {/expired|already been used|incomplete/i.test(error) && (
                    <Link to="/email-verify">Request a new link</Link>
                  )}
                </p>
              )}
              <Form onSubmit={handleSubmit}>
                <p className="input_lbl" style={{ marginTop: 10 }}>
                  New password
                </p>
                <div className="reset_input_div" style={{ marginTop: -10 }}>
                  <input
                    className="reset_input_field"
                    type="password"
                    placeholder="**********"
                    name="newPassword"
                    autoComplete="new-password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </div>
                <p className="input_lbl" style={{ marginTop: 20 }}>
                  Confirm new password
                </p>
                <div className="reset_input_div" style={{ marginTop: -10 }}>
                  <input
                    className="reset_input_field"
                    type="password"
                    placeholder="**********"
                    name="confirmPassword"
                    autoComplete="new-password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
                <Button type="submit" className="submit_btn" style={{ marginTop: 40 }} disabled={saving}>
                  {saving ? "Saving..." : "Set new password"}
                </Button>
              </Form>
            </>
          )}
          <br />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
